<template>
    <div class="h-full">
        <div
            v-if="isLoading || !product"
            class="flex gap-2 shadow-37 shadow-gray-200 dark:shadow-sandstone-900 bg-white dark:bg-sandstone-800 rounded-md p-2"
        >
            <div class="w-5/12 flex flex-col justify-between pr-2 py-2">
                <div>
                    <USkeleton class="h-6 w-7/12" />
                    <UDivider class="w-2/3 mt-2" />
                </div>
                <div>
                    <USkeleton class="h-3 w-1/3" />
                    <USkeleton class="h-5 w-1/2 mt-2" />
                </div>
            </div>
            <div class="w-7/12 aspect-square">
                <USkeleton class="w-full h-48 aspect-square" />
            </div>
        </div>
        <div
            v-else
            class="flex gap-2 shadow-37 shadow-sandstone-100 dark:shadow-sandstone-900 bg-white dark:bg-sandstone-800 rounded-md p-2 h-full group transition-all duration-300 hover:shadow-58 hover:shadow-sandstone-200/75"
        >
            <div class="w-5/12 flex flex-col justify-between pr-2 py-2">
                <div>
                    <NuxtLink class="w-full" :to="`/product/${product?.slug}`">
                        <UiComponentTypography tag="h3" variant="h5" class-name="text-vista-900 dark:text-vista-100">
                            {{ product?.name }}
                        </UiComponentTypography>
                    </NuxtLink>
                    <UDivider class="w-1/3 border-t-2 rounded-full dark:border-sandstone-700" />
                    <UiComponentTypography variant="subtitle2" class-name="mt-2">
                        {{ product.about }}
                    </UiComponentTypography>
                </div>
                <div>
                    <div v-if="!product?.is_in_stock">
                        <UiComponentTypography variant="h6" class-name="text-slate-500">
                            ناموجود
                        </UiComponentTypography>
                    </div>
                    <div v-else-if="product?.price">
                        <WidgetsProductPrice :price="product?.price" :discount="product?.discounted_price" />
                    </div>
                    <div class="hidden lg:block">
                        <UButton
                            :icon="
                                product?.is_in_stock ? 'i-solar-cart-large-line-duotone' : 'i-solar-box-line-duotone'
                            "
                            :to="`/product/${product?.slug}`"
                            variant="outline"
                            block
                            class="mt-2"
                        >
                            {{ product?.is_in_stock ? "خرید" : "مشاهده" }}
                        </UButton>
                    </div>
                </div>
            </div>
            <div class="w-7/12 aspect-square">
                <NuxtLink class="w-full h-full" :to="`/product/${product?.slug}`">
                    <NuxtImg
                        class="group-hover:scale-105 transition-transform duration-1000 ease-in-out w-full h-full object-contain"
                        :alt="product?.name || 'محصول نرس‌لند'"
                        :src="productImageUrl"
                        preset="thumbnail"
                        fit="contain"
                        background="white"
                        :loading="eager ? 'eager' : 'lazy'"
                        :fetchpriority="eager ? 'high' : 'auto'"
                        sizes="150px sm:200px lg:300px"
                    />
                </NuxtLink>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { IProduct } from "~/libs/types/api/product";

const props = defineProps({
    product: {
        type: Object as PropType<IProduct>,
    },
    isLoading: {
        type: Boolean,
        default: false,
    },
    eager: {
        type: Boolean,
        default: false,
    },
});

const productImageUrl = computed(() => {
    if (!props.product?.feature_image) return "/Images/logo/logo.png";
    const images = Object.values(props.product.feature_image);
    return images[0]?.original_url || "/Images/logo/logo.png";
});
</script>

<style></style>
